import { Route } from '@angular/router';
import { OPERATOR_ACCESS_ROLES } from '@app/core/services/http/auth/auth.service';

export const userParametersRoutes: Route = {
  path: 'user-parameters',
  data: { roles: [...OPERATOR_ACCESS_ROLES] },
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'client-contact' },
    {
      path: 'client-contact',
      data: { titleKey: 'components.adminLayout.sidebar.menu.clientContact' },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'manager-contact',
      data: { titleKey: 'components.adminLayout.sidebar.menu.managerContact' },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'clients',
      data: { titleKey: 'components.adminLayout.sidebar.menu.clients' },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'managers',
      data: { titleKey: 'components.adminLayout.sidebar.menu.managersRegistry' },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
    {
      path: 'payments',
      data: { titleKey: 'components.adminLayout.sidebar.menu.payments' },
      loadComponent: () =>
        import('../../shared/section-placeholder/section-placeholder.component').then(
          m => m.SectionPlaceholderComponent
        ),
    },
  ],
};
